import React from 'react';
import classNames from 'classnames';

import CategoryIcon from '../../../components/CategoryIcon/CategoryIcon';

import css from './MapCategoryPin.module.css';

/**
 * One map pin: the listing's category icon in a round marker (the NOW logo when
 * the category has none), with a count when several listings share the spot.
 * Mirrors the mobile app's service pin.
 */
const MapCategoryPin = ({ category, parent, count, isActive, onClick, title }) => (
  <button
    type="button"
    className={classNames(css.pin, { [css.active]: isActive })}
    onClick={onClick}
    title={title}
    aria-label={title}
  >
    <span className={css.ring}>
      <CategoryIcon category={category} parent={parent} className={css.icon} />
      {count > 1 ? <span className={css.count}>{count > 99 ? '99+' : count}</span> : null}
    </span>
    <span className={css.caret} />
  </button>
);

export default MapCategoryPin;
